import styled from 'styled-components'  

import {
    Animation
} from 'ui/styled'

export const DashboardTitle = styled.div.attrs({ 
})`            
    font-size: 22px;
    font-weight: bold;
    color: ${ props => props.theme.palette.colors.black };
    margin-bottom: 12px;
    ${
        props => props.centred ? `
            text-align: center;
        ` : ``
    }
`;

export const DashboardText = styled.div.attrs({ 
})`            
    font-size: 16px;
    line-height: 26px;
    color: ${ props => props.theme.palette.colors.black };
    ${
        props => props.centred ? `
            text-align: center;
        ` : ``
    }
`;

export const DashboardAnimation = styled(Animation).attrs({ 
    width: '100%',
    height: 420
})`             
`;






export const PoolLabelsSpacer = styled.div.attrs({ 
})`             
    padding-top: 152px;
`;

export const PoolLabels = styled.div.attrs({ 
})`             
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
`;

export const LabelContentOutShadow = styled.div.attrs({ 
})`             
    box-shadow: 0px 3px 6px rgba(0,0,0,.1);
    border-radius: 6px;
`;

export const LabelContentOut = styled.div.attrs({ 
})`             
    overflow: hidden;
    border-radius: 6px;
`;

export const LabelContent = styled.div.attrs({ 
})`             
    display: flex;
    box-shadow: 0px 3px 6px rgba(0,0,0,.1);
`;

export const LabelTitle = styled.div.attrs({ 
})`             
    background: ${ props => props.theme.palette.colors.blue };
    color: ${ props => props.theme.palette.colors.white };
    padding: 6px 12px; 
`;
    
export const LabelInfo = styled.div.attrs({ 
})`             
    background: ${ props => props.theme.palette.colors.background };
    padding: 6px 12px; 
`;

export const ContentFilter = styled.div.attrs({ 
})`            
    width: 100%;
    max-width: 320px;
    @media(max-width: 1002px){
        max-width: 100%;
    }
`;
 

export const ContentFilterAction = styled.div.attrs({ 
})`            
    display: flex;
    align-items: flex-end;
    padding: 0 0 12px 0;
    gap: 12px ;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
`;

export const ContentTableAction = styled.div.attrs({ 
})`            
    max-width: 180px;
    min-width: 160px; 
`;

export const ContentTableActionIcon = styled.img.attrs({ 
    src: '/icons/upload.svg',
    width: 12
})`          
    margin-left: 10px;   
`;

export const ContentTableActionPrint = styled.img.attrs({ 
    src: '/icons/print.svg',
    width: 12
})`          
    margin-left: 10px;   
`;

export const Wrapper = styled.div.attrs({ 
})`            
    display: flex;
    align-items: center;
    gap: 12px;
    `